module.exports = __webpack_public_path__ + "images/drawings/stars.3523edae4f187d7d91a039c0c9bd8207.png";